import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

const PlantBurger = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    return (
      <div ref={ref} {...props} className={cn(css.burger, props.className)}>
        <div className="w-6 h-[2px] flex gap-[2px]">
          <span className="flex-1 h-full bg-white/70 rounded-[20%]"></span>
          <span className="w-1 h-full bg-white/70 rounded-[20%]"></span>
        </div>
        <div className="w-6 h-[2px] flex gap-[2px]">
          <span className="w-1 h-full bg-white/70 rounded-[20%]"></span>
          <span className="flex-1 h-full bg-white/70 rounded-[20%]"></span>
        </div>
        <div className="w-6 h-[2px] flex gap-[2px]">
          <span className="flex-1 h-full bg-white/70 rounded-[20%]"></span>
          <span className="w-1 h-full bg-white/70 rounded-[20%]"></span>
        </div>
      </div>
    );
  },
);

export { PlantBurger };
